export default __webpack_public_path__ + "static/media/23.c85d5a97.png";